// im messages slice 
//categories in the messages data
// to add category need add data to the slice 


const chooseMessagesData1 = (data, selectedCategory) => {
console.log('1.1.2.3 Start choose message data');
//console.log(data);
//console.log(selectedCategory);

    let messagesData;
if (selectedCategory === 1) {
    messagesData = data.messagesUserDataInbox;
}
if (selectedCategory === 2) {
    messagesData = data.messagesUserDataSend;
}
if (selectedCategory === 3) {
    messagesData = data.messagesDataAdmin;
}
//console.log(messagesData);
    return messagesData;
}
export {chooseMessagesData1};